import { Messages } from '../../../../codegen/Localize';
import { ILocale } from '../../../../httpClient/serverApi/types/ILocale';
import WebHttpClient from '../../../../httpClient/WebHttpClient';
import { GetLocalesRequest } from '../../serverApi/requests/unownedSettings/GetLocalesRequest';

export class Locales {

  public getAll(): Promise<ILocale[]> {
    return WebHttpClient.sendRequest(new GetLocalesRequest()).then(result => result.locales);
  }

  // a special value for the user locale that indicates that we should use the server locale
  public unspecifiedLocale(): ILocale {
    return {
      displayName: Messages.unspecified(),
      locale: null
    };
  }

}

export const LocalesInstance = new Locales();
